export const generalOptions = [
	{ label: '1톤', value: '1t' },
	{ label: '2톤', value: '2t' },
	{ label: '3톤', value: '3t' },
	{ label: '1-2톤', value: '1-2t' },
	{ label: '2-3톤', value: '2-3t' },
	{ label: '1-3톤', value: '1-3t' },
	{ label: '5톤', value: '5t' },
	{ label: '54M', value: '54m' },
	{ label: '58M', value: '58m' },
	{ label: '75M', value: '75m' },
];

export const guljeolOptions = [
	{ label: '28M', value: '28m' },
	{ label: '40M', value: '40m' },
	{ label: '60M', value: '60m' },
	{ label: '70M', value: '70m' },
];

export type Option = { value: string; label: string };
